import type { Track } from '@tunasong/schemas'
import type { FC } from 'react'

export interface DetailsProps {
  className?: string
  track?: Track
}

export const Details: FC<DetailsProps> = props => {
  const { className, track } = props

  if (!track) {
    return null
  }
  return <div className={className}>{track.name}</div>
}

export default Details
